import ManualEntry from './ManualEntry.js';

export default ManualEntry;
